import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';

export default function SetupInitialMoney({ open, onClose, bank }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        className: 'rounded-3xl overflow-hidden shadow-2xl',
      }}
    >
      {/* Gradient Header */}
      <Box className="bg-gradient-to-br from-blue-600 via-violet-600 to-indigo-700 py-4 px-6 relative overflow-hidden">
        {/* Decorative circles */}
        <Box className="relative z-10 text-center">
          <DialogTitle className="text-center font-bold text-white text-3xl  mb-2">
            ข้อมูลเงินตั้งต้น
          </DialogTitle>
        </Box>
      </Box>

      <DialogContent className="bg-slate-50 py-6 px-6">
        <Box className="space-y-5">
          {bank?.map((item, index) => (
            <Box
              key={item._id}
              className="bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              {/* Colored top bar */}
              <div
                className="h-1"
                style={{
                  background:
                    index % 2 === 0
                      ? 'linear-gradient(90deg, #0642daff 0%, #e0e2f1ff 100%)'
                      : 'linear-gradient(90deg, #1a2cd1ff 0%, rgba(175, 181, 227, 1) 100%)',
                }}
              />

              <Box className="p-6">
                {/* Header */}
                <Box className="flex justify-between items-center mb-5">
                  <Typography className="font-bold text-slate-800 text-xl">
                    {item.name}
                  </Typography>

                  <Box className="bg-slate-100 text-slate-600 text-sm font-semibold px-4 py-1.5 rounded-lg">
                    {item.bankName}
                  </Box>
                </Box>

                {/* Amount Display */}
                <Box className="bg-blue-to-br from-blue-50 to-indigo-50 border-2 border-indigo-200 rounded-xl px-6 py-5 flex items-center justify-between">
                  <Box>
                    <Typography className="text-indigo-600 text-sm font-semibold mb-1 tracking-wide">
                      เงินตั้งต้น (START AMOUNT)
                    </Typography>

                    <Typography className="text-4xl font-extrabold text-indigo-700 tracking-tight">
                      {item.startAmount?.toLocaleString()} ฿
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions className="p-6 bg-white border-t border-slate-200">
        <Button
          onClick={onClose}
          variant="contained"
          fullWidth
          className="bg-gradient-to-r from-purple-600 to-indigo-700 hover:from-purple-700 hover:to-indigo-800 text-white font-bold text-lg py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 normal-case"
        >
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
